import { render, staticRenderFns } from "./UserProfilePage.vue?vue&type=template&id=602c7087&scoped=true&"
import script from "./UserProfilePage.vue?vue&type=script&lang=js&"
export * from "./UserProfilePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602c7087",
  null
  
)

export default component.exports